/*
 * LoadingStore.
 *
 * The purpose of this is to hold various loadStates from various components.
 *
 * We use this data aggregated into one place to determine whether to show
 * a full-screen loading spinner on the map. We use
 */
import { get, writable } from "svelte/store";
import LoadState from "./Enums/LoadState";

const LoadingStore = {
	_subscriptions: {

	},
	_states: {

	},
	loading: writable(false),

	add: (key, loadState) => {
		LoadingStore._states[key] = loadState;
		LoadingStore._subscriptions[key] = LoadingStore._states[key].subscribe((newState) => {
			LoadingStore.update();
		});
	},
	remove: (key) => {
		LoadingStore._subscriptions[key]();
		delete LoadingStore._subscriptions[key];
		delete LoadingStore._states[key];
	},

	// helper function -- return this in a component onMount() call;
	onMount: (key, loadState) => {
		LoadingStore.add(key, loadState);
		return () => {
			LoadingStore.remove(key);
		};
	},

	update: () => {
		let loading = false;
		const keys = Object.keys(LoadingStore._states);
		for (let i = 0; i < keys.length; i++) {
			if (get(LoadingStore._states[keys[i]]) === LoadState.LOADING) {
				loading = true;
				break;
			}
		}
		LoadingStore.loading.set(loading);
	}
};
export default LoadingStore;
